import { render, staticRenderFns } from "./TwoColumnTextCollapsableModule.vue?vue&type=template&id=4975e99c&"
import script from "./TwoColumnTextCollapsableModule.ts?vue&type=script&lang=ts&"
export * from "./TwoColumnTextCollapsableModule.ts?vue&type=script&lang=ts&"
import style0 from "./TwoColumnTextCollapsableModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports